import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-info-details',
  templateUrl: './info-details.component.html',
  styleUrls: ['./info-details.component.scss']
})
export class InfoDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
